import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import { PageSkeleton } from '../../components/loading/skeletons';
import { ADMIN_PATHS, adminPath } from '../constants/adminPaths';

const SuperAdminRoute = ({ children }) => {
  const { admin, authUser, loading, error } = useAdminAuth();

  if (loading || (authUser && !admin && error)) {
    return <PageSkeleton fill label="Loading admin" />;
  }

  if (!admin) {
    return <Navigate to={adminPath(ADMIN_PATHS.LOGIN)} replace />;
  }

  if (admin.role !== 'super-admin') {
    return <Navigate to={adminPath(ADMIN_PATHS.TOOLS)} replace />;
  }

  return children;
};

export default SuperAdminRoute;
